import React, { useState, useEffect } from "react";
import { Box, Typography, List, ListItem, ListItemText, Divider, CircularProgress, Button, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams, useNavigate } from "react-router-dom";
import MenuSection from "../components/MenuSection";
import SaldoCliente from "../api/getSaldoCliente";
import apiErrorHandler from "../helpers/apiErrorHandler";

const SaldosCtacte = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isTwoColumns = useMediaQuery("(min-width:700px)");
  const { idCliente, nombreCliente } = useParams();
  const [saldos, setSaldos] = useState([]);
  const [saldoCuentaCorriente, setSaldoCuentaCorriente] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSaldos = async () => {
      if (idCliente) {
        try {
          const data = await SaldoCliente.getSaldo(idCliente);

          const formattedSaldos = [
            { label: "Cheques no acreditados", value: data.chequesTerceros },
            { label: "Remitos no facturados", value: data.remitosNoFacturados },
            {
              label: "Pedidos no remitidos y no facturados",
              value: data.pedidosNoRemitidosYNoFacturados,
            },
            { label: "Límite crédito", value: data.limiteCredito },
            { label: "Límite restante", value: data.limiteRestante },
          ];

          setSaldos(formattedSaldos);
          setSaldoCuentaCorriente(data.saldoCtaCte);
        } catch (error) {
          console.error("Error al obtener los saldos:", error);
          apiErrorHandler(error, { stopFlow: true });
        } finally {
          setLoading(false);
        }
      }
    };

    fetchSaldos();
  }, [idCliente]);

  return (
    <>
      <MenuSection />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            backgroundColor: "white",
          }}
        >
          <CircularProgress size={48} sx={{ color: theme.bandera.colorSecundario, mb: 2 }} />
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Cargando datos del Cliente...
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            width: isTwoColumns ? "800px" : "360px",
            margin: "0 auto",
            backgroundColor: "white",
            p: 3,
          }}
        >
          {nombreCliente && (
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center", mt: 3, mb: 1 }}>
                {decodeURIComponent(nombreCliente)}
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#f9f9f9",
                  pt: 1,
                  mb: 1,
                  textAlign: "center",
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  Saldo en Cuenta Corriente
                </Typography>
                {saldoCuentaCorriente !== null && (
                  <Typography
                    variant="h5"
                    sx={{
                      color: saldoCuentaCorriente < 0 ? "red" : "green",
                      fontWeight: "bold",
                    }}
                  >
                    $
                    {saldoCuentaCorriente.toLocaleString("es-AR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                )}
              </Box>
            </Box>
          )}

          <Grid container spacing={1}>
            {saldos.map((saldo, index) => (
              <Grid sx={{ p: 0 }} item xs={isTwoColumns ? 6 : 12} key={index}>
                <Box
                  sx={{
                    backgroundColor: "#f4f4f4",
                    borderRadius: 1,
                    p: 1.5,
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold", mb: 0.5 }}>
                    {saldo.label}
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: "bold", color: saldo.value < 0 ? "red" : "green" }}>
                    $
                    {saldo.value.toLocaleString("es-AR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Box sx={{ textAlign: "right" }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.bandera.colorSecundario,
                fontWeight: "bold",
                mt: 2,
                color: "black",
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                  opacity: 0.9,
                },
              }}
              onClick={() => navigate("/dashboard")}
            >
              Volver
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SaldosCtacte;
